/**
 * Escape a cell value for inclusion in a CSV row. Shared by the
 * inventory and change-log exports so they apply the same
 * round-trip-safe normalization and formula-injection mitigations.
 *
 * - Embedded CR/LF are collapsed to a single space because the line-
 *   based parser splits on newlines before honoring quotes, so a
 *   multi-line quoted cell wouldn't round-trip cleanly.
 * - Cells whose first non-whitespace character is a spreadsheet
 *   formula trigger (`=`, `+`, `-`, `@`) get a leading `\t` so Excel
 *   / Sheets render them as text. Match past leading whitespace
 *   because spreadsheet apps trim leading spaces before deciding
 *   whether to evaluate the cell, so `" =SUM(1,2)"` is just as
 *   dangerous as `"=SUM(1,2)"`. The tab is stripped on re-import by
 *   {@link parseInventoryCsv} (it `trim()`s each cell).
 * - Cells containing `"` or `,` are wrapped in double quotes per
 *   RFC 4180, with internal `"` doubled.
 */
export function escapeCsvCell(value: string | number): string {
    const normalized = String(value).replace(/[\r\n]+/g, ' ');
    const text = /^\s*[=+\-@]/.test(normalized) ? `\t${normalized}` : normalized;
    if (!/[",]/.test(text)) return text;
    return `"${text.replace(/"/g, '""')}"`;
}
